import { ONE_INCH_IN_METERS } from 'constants/editor/room';

const convertInchesToMeters = (...inches: number[]): number[] =>
  inches.map((inch) => inch / ONE_INCH_IN_METERS);

export default convertInchesToMeters;
